import { Suspense, lazy } from "react";

const LogoIcon = lazy(() => import("../../../assets/images/svg/logoIcon.svg").then((logo) => ({ default: logo.ReactComponent })));

const LogoWithoutName = () => {
    const handleGetLogo = () => {
        return (
            <Suspense fallback={<div className="skeleton rounded-full h-[30px] w-[30px]"></div>}>
                <LogoIcon />
            </Suspense>
        );
    };

    return handleGetLogo();
};

export default LogoWithoutName;
